import React, { forwardRef } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { InputEvent } from 'Components/Common/Form/form';
import MessageError from 'Components/Common/MessageError';
// import { labelRequire } from 'Components/Common/Form/FormLabel';
import { InputProps } from './form-group-text-area';
import HintTextField from 'Components/Common/Form/HintTextField';

const ECFormGroupTextArea = forwardRef((props: InputProps, ref: any): JSX.Element => {
  const {
    label,
    classForm,
    errorMessage,
    placeholder,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    labelMd,
    colMd,
    value,
    register,
    onChange,
    hintText = '',
    disabled = false,
    isReview = false,
    maxLength,
    messageWrapper,
    classInput,
    onKeyPress,
    rows = 3,
  } = props;

  const handleOnchange = (e: InputEvent) => {
    if (onChange && !isReview) {
      onChange(e.target.value);
    }
  };

  return (
    <Form.Group as={Row} className={`mb-3 ${classForm}`}>
      {label}

      <Col md={colMd}>
        <textarea
          {...register}
          value={value ?? ''}
          onChange={handleOnchange}
          placeholder={placeholder}
          disabled={disabled || isReview}
          maxLength={maxLength}
          className={`${classInput} form-control`}
          autoComplete="off"
          rows={rows}
          onKeyPress={onKeyPress}
          ref={ref}
        />
        <HintTextField hintText={hintText} />
        <MessageError classWrapper={messageWrapper} message={errorMessage} />
      </Col>
    </Form.Group>
  );
});

export default ECFormGroupTextArea;
